<template>
    <div class="container" id="blogHome">

        <div class="header">
            <h2>NOVEDADES</h2>
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <p>Ingrese a nuestro blog y enterese de las ultimas noticias del mundo automotor</p>
                </div>
            </div>
        </div>

        <div class="blog">
            
            <div class="row">
                <div class="col-md-8 offset-md-2 post" v-for="post in posts">
                    <div>
                    <h3>{{post.titulo}}</h3>
                    <p>{{post.descripcionCorta}}</p>
                    <div class="clearfix">
                    <router-link :to="{ name: 'postItem', params: { id: post.key }}" class="btn btn-sm btn-default float-xs-right">
                        LEER MAS +
                    </router-link>
                    </div>
                    </div>
                    <hr />
                </div>
            </div>
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <button v-if="nuevos" @click="nextPosts" class="btn btn-info btn-block">MAS NOTICIAS</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import BlogService from '../services/blog/blog.service.js'
import PostItem from './Post-Item'

let blogService = new BlogService();

export default {
    name: 'blog-home',
    components: {
        PostItem,
    },

    data () {
        return {
            posts: null,
            lastKey: null,
            nuevos: true
        }
    },
    
    created () {
        var cmp = this;

        blogService.lastPosts( nuevosPosts => 
        {
            cmp.nuevos = nuevosPosts.length == 2;

            nuevosPosts.sort(function (a, b) {
                return (a["timestamp"] < b["timestamp"] ? 1 : -1);
            });
            
            cmp.posts = nuevosPosts;

            cmp.lastKey = cmp.posts[cmp.posts.length - 1].timestamp - 1;
            console.log('last key: ' + cmp.lastKey);
        });
        
    },

    methods: {
        nextPosts () {
            var cmp = this;
            var nextPosts = blogService.nextPosts(cmp.lastKey,  nuevosPosts => 
            {
                cmp.nuevos = nuevosPosts.length == 2;

                nuevosPosts.sort(function (a, b) {
                    return (a["timestamp"] < b["timestamp"] ? 1 : -1);
                });

                var nuevos = cmp.posts.concat(nuevosPosts);
                cmp.posts = nuevos;

                cmp.lastKey = cmp.posts[cmp.posts.length - 1].timestamp - 1;
                console.log('last key: ' + cmp.lastKey);
            });


            

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        font-weight: bold;
    }
    p {
        font-size: 21px;
    }
    .btn-default {
        background-color:#196C7E;
        color:#fff;
        border-radius: 0px;
    }
    .btn-info {
        margin-top: 50px;
    }
    .copyright {
        margin-top:30px;
    }
</style>



// WEBPACK FOOTER //
// Blog-Home.vue?072ce232